import { useLocation } from "react-router-dom";

export interface ClickParams {
    pageId?: string;
    eventId: string;
    pageName?: string;
    eventParams?: object;
    eventName?: string;
    pageParams?: string;
}

declare function log(pageId: string, eventId: string, ...params: any): void;

export const useLogUtil = () => {
    const pageId: any = (useLocation().pathname || "")
        .replace(/\//g, "")
        .replace(/-/g, "_");

    /**
     * 点击埋点
     * @param options
     */
    const click = (options: ClickParams = {} as any) => {
        const { eventId, eventName = "" } = options;
        let { eventParams = "" } = options;
        if (eventParams && typeof eventParams == "object") {
            try {
                eventParams = JSON.stringify(Object.assign({}, eventParams));
            } catch (e) {
                console.log("埋点eventParams参数异常");
            }
        }

        log(pageId, eventId, eventParams, eventName);
    };

    return {
        log: click,
    };
};
